import React from 'react';
import {Slide, ToastContainer, TypeOptions} from "react-toastify";
import {AlertCircle, AlertTriangle, CheckCircle2, Info} from "lucide-react";
import './Toaster.scss';

// Icon tiles in the app's style instead of toastify's default icons
const icons: Partial<Record<TypeOptions, React.ReactNode>> = {
    success: <CheckCircle2 size={18}/>,
    error: <AlertCircle size={18}/>,
    warning: <AlertTriangle size={18}/>,
    info: <Info size={18}/>,
    default: <Info size={18}/>,
};

// The app's single toast container; call toast() anywhere as before
const Toaster = () => (
    <ToastContainer
        className="Toaster"
        position="top-right"
        autoClose={4000}
        transition={Slide}
        newestOnTop
        limit={3}
        theme="light"
        icon={({type}) => <span className={`Toaster__icon Toaster__icon--${type}`}>{icons[type]}</span>}
    />
);

export default Toaster;
